var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mh" },
    [
      _c("UiTextbox", {
        ref: "textbox",
        staticClass: "textbox",
        style: _vm.changedOrFocused ? _vm.$coreOutline : {},
        attrs: {
          label: _vm.label,
          disabled: _vm.disabled,
          invalid: _vm.showInvalidMessage,
          error: _vm.invalidText,
          autofocus: _vm.autofocus,
          maxlength: _vm.maxlength,
          autocomplete: _vm.autocomplete,
          autocapitalize: _vm.autocapitalize,
          type: _vm.type,
          min: _vm.min,
          max: _vm.max,
          enforceMaxlength: true,
          floatingLabel: _vm.floatingLabel,
          multiLine: _vm.textArea,
          rows: 3,
        },
        on: {
          input: _vm.updateText,
          keydown: _vm.emitKeydown,
          focus: _vm.emitFocus,
          blur: _vm.emitBlur,
        },
        model: {
          value: _vm.currentText,
          callback: function ($$v) {
            _vm.currentText = $$v
          },
          expression: "currentText",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }